import React, { useState, useRef, useEffect } from "react"
import styled from "styled-components"
import {
  BASE_URL,
  // LOGIN_URL,
  LOGOUT_URL,
  // PROFILE_PAGE_URL,
  // APP_ID,
} from "../helpers/constants"
// import decodeUserToken from "../helpers/decodeUserToken"
import {
  // decodeUserToken, 
  inBrowser
} from "@omnichannel/ace-b2b-elements"
import fetch from "unfetch"
// import { ExitToApp } from "styled-icons/material"
// import { User } from "@styled-icons/boxicons-solid/User"
import { navigate } from "gatsby"
import { MobileView, WebView } from "../styles/common"
import withApolloClient from "../components/withApolloClient"
import { useQuery } from "@apollo/react-hooks"
import gql from "graphql-tag"
import {
  getShoppingCartQueryGQL,
} from "../components/gql/cart"

// const UserIcon = styled(User)`
//   cursor: pointer;
// `

// const ExitToAppIcon = styled(ExitToApp)`
//   cursor: pointer;
//   margin-left: -.4rem;
// `

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0.9rem;
  width: 100%;
  @media (min-width: 768px) {
    width: auto;
  }
`

const Details = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transform: translate(-0.2rem, 0rem);
  width: 100%;
`

const Text = styled.div`
  /* background-color: blue; */
  width: 100%;
  color: #fff;
  margin: auto 0.4rem;
  font-size: ${props => (props.drawer ? "1.4rem" : "1.2rem")};
  font-weight: 100;
  cursor: ${props => (props.isLoggedIn ? "pointer" : "")};
  @media (min-width: 1200px) {
    display: block;
  }
  @media (max-width: 767px) {
    display: block;
    margin: .2rem;
  }
`

const ActionText = styled.a`
  user-select: none;
  color: #fff;
  font-size: 1.8rem;
  font-weight: 700;
  padding: 0 0.2rem;
  cursor: pointer;
  transition: all 500ms;
  display: inline-block;
  @media (min-width: 768px) {
    padding: 0;
    font-size: 1.4rem;
    font-weight: 500;
  }
  &:hover {
    transition: all 100ms;
    /* transform: scale(1.1, 1.1); */
  }
  &:active {
    transform: scale(0.98, 0.98);
  }
`

const UserContainer = styled.div`
  width: 50%;
  color: #fff;
  font-size: 1.2rem;
  a {
    text-decoration: none;
    color: #fff;
  }
`

// const AccountMenuBox = styled.div`
//   position: absolute;
//   top: 5.6rem;
//   right: 0;
//   /* height: 10rem; */
//   width: 17rem;
//   border-radius: .2rem;
//   /* background-color: ${props => props.theme[APP_ID].tertiary}; */
//   /* background-color: #E8171E; */
//   /* background-color: #ef0a0a; */
//   background-color: #fa0404;
//   box-shadow: 0 .1rem .2rem rgba(0,0,0, .2);
//   color: #FFF;
//   padding: 1rem 1rem .8rem 1rem;
// `

// const MenuItem = styled.div`
//   font-size: 1.2rem;
//   text-transform: uppercase;
//   padding: 0.4rem 0;
//   cursor: pointer;
// `

// const MenuItemDivider = styled.div`
//   border-bottom: 1px #fff solid;
//   height: 0.1rem;
//   margin: 0.4rem 0 0.4rem 0;
// `

const DrawerUserBox = styled.div`
  display: flex;
  width: 100%;
  margin: 1.6rem 0.8rem 0 0.6rem;
  /* background-color: yellow; */
`

function UserInfo(props) {
  const [loading, setLoading] = useState(false)
  const [profileMenu, setProfileMenu] = useState(false)
  const profileMenuRef = useRef()
  const [userInfo, setUserInfo] = useState({})

  const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
  // console.log("accessToken::", accessToken)
  // if (accessToken) {
  //   userInfo = decodeUserToken && decodeUserToken(accessToken)
  //   console.log("after decoding userInfo::", userInfo)
  // }


  const { data, loading: userInfoLoading } = useQuery(
    gql`
      query userInfoQuery {
        getUserInfo {
          email
          name
          companyId
        }
      }
    `, 
  )

  const shoppingCart = useQuery(getShoppingCartQueryGQL, {
    fetchPolicy: "network-only",
    context: { headers: {
      companyId: localStorage.getItem("company-id"),
      email: localStorage.getItem("user-email")
    }}
  })

  useEffect(() => {
    let userInfo = null
    let localUserEmail = localStorage.getItem("user-email")
    if (!userInfoLoading) {
      userInfo = data && data.getUserInfo
      setUserInfo(userInfo)
      if (inBrowser && userInfo && userInfo.companyId && 
          userInfo.email && userInfo.name) {
        localStorage.setItem("company-id", userInfo.companyId)
        localStorage.setItem("user-email", userInfo.email)
        localStorage.setItem("user-name", userInfo.name)

        if( (localUserEmail !== userInfo.email) && localStorage.getItem("user-email") && localStorage.getItem("company-id")) {
          shoppingCart.refetch();
          console.log("shoppingCart.refetch")
        }

        // shoppingCart.refetch();
        // console.log("shoppingCart.refetch")
      } else {
        onLogout()
      }

    } 
  }, [userInfoLoading, data, shoppingCart])


  // const onLogin = () => {
  //   if (props.closeDrawer) props.closeDrawer()

  //   window.location.href = `${LOGIN_URL}/?redirectUrl=${encodeURIComponent(
  //     BASE_URL
  //   )}&appId=${APP_ID}`
  // }

  // const onSignup = () => {
  //   if (props.closeDrawer) props.closeDrawer()
  //   window.location.href = `${LOGIN_URL}/sign-up?redirectUrl=${encodeURIComponent(
  //     BASE_URL
  //   )}`
  // }

  // const onProfileClick = () => {
  //   if (props.closeDrawer) props.closeDrawer()

  //   if (userInfo?.firstName) {
  //     window.location.href = PROFILE_PAGE_URL
  //   }
  // }

  const onLogout = () => {
    if (props.closeDrawer) props.closeDrawer()
    let bearerAccessToken = "x"
    const accessToken = localStorage.getItem("access-token") || ""
    if (accessToken.length) {
      bearerAccessToken = `Bearer ${accessToken}`
    }

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: bearerAccessToken,
    }

    const body = new URLSearchParams()
    body.append("userId", userInfo._id, userInfo)

    const requestOptions = {
      method: "POST",
      headers,
      body,
    }

    // fetch(LOGOUT_URL, requestOptions)

    //.finally(() => {
    // endZendeskSession()
    // localStorage.removeItem("access-token")
    // localStorage.removeItem("refresh-token")
    // window.location = BASE_URL
    // setLoading(false)
    //})

    //seems like there is no need to wait
    //that is why i placed it here to make logout faster
    setTimeout(() => {
      localStorage.removeItem("company-id")
      localStorage.removeItem("user-email")
      localStorage.removeItem("user-name")
      localStorage.removeItem("access-token")
      localStorage.removeItem("refresh-token")
      window.location = BASE_URL
    }, 100)

  }


  // const hideProfileMenu = () => {
  //   setProfileMenu(false)
  // }

  // const handleClickOutsideOfProfileMenu = e => {
  //   if (profileMenuRef.current && profileMenuRef.current.contains(e.target)) {
  //     return
  //   }
  //   hideProfileMenu()
  // }

  // useEffect(() => {
  //   window.addEventListener("mousedown", handleClickOutsideOfProfileMenu)
  //   // console.log("handleClickOutsideOfProfileMenu listener Created")
  //   return () => {
  //     // console.log("handleClickOutsideOfProfileMenu listener Cleaned up")
  //     window.removeEventListener("mousedown", handleClickOutsideOfProfileMenu)
  //   }
  // }, [])

  // const handleProfileMenuItemClik = path => {
  //   hideProfileMenu()
  //   navigate(path)
  // }

  return (
    <>
      <MainContainer drawer={props.drawer}>
        <WebView>
          <Details drawer={props.drawer}>
            <Text drawer={props.drawer}>
              {userInfo?.name && (
                <>
                  <ActionText
                  // onClick={() => {
                  //   setProfileMenu(true)
                  // }}
                  >
                    <span style={{ whiteSpace: "nowrap" }}>
                      {userInfo.name.toUpperCase()}
                    </span>
                  </ActionText>
                  <ActionText >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</ActionText>
                  <ActionText onClick={onLogout}>Log out</ActionText>
                </>
              )}

            </Text>
            {/* {userInfo?._id ? <UserIcon
              size={"2.2rem"}
              color={"#fff"}
              onClick={() => {
                setProfileMenu(true)
              }}
            /> : <ExitToAppIcon size={"3rem"} color={"#fff"} onClick={onLogin} />} */}
          </Details>
        </WebView>
        <MobileView style={{ width: '100%' }}>
          <Details drawer={props.drawer}>
            <DrawerUserBox >
              <Text drawer={props.drawer}>
                {userInfo?.name ? (
                  <div style={{ display: "flex", justifyContent: 'space-between', width: "100%", alignItems: "center" }}>
                    <div style={{
                      fontSize: '1.8rem',
                      fontWeight: '500'
                    }}
                      onClick={() => {
                        if (props.closeDrawer) props.closeDrawer()
                        navigate("/account/profile")
                      }}
                    ><span>{userInfo.name.toUpperCase()}</span></div>
                    <ActionText onClick={onLogout}>Log out</ActionText>
                  </div>
                ) : (
                    <div style={{ display: "flex", justifyContent: 'space-between', width: "100%", alignItems: "center" }}>

                      <div style={{ fontSize: '1.8rem', fontWeight: '500' }}>Hi <span>SHOPPER</span></div>
                      {/* <ActionText onClick={onLogin}>Log in</ActionText> */}
                    </div>
                  )}
              </Text>
            </DrawerUserBox>
          </Details>
        </MobileView>

      </MainContainer>
      {/* {profileMenu && (
        <AccountMenuBox ref={profileMenuRef}>
          <MenuItem
            onClick={() => {
              handleProfileMenuItemClik("/account/profile")
            }}
          >
            Profile
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleProfileMenuItemClik("/account/address")
            }}
          >
            Address
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleProfileMenuItemClik("/account/loyaltycard")
            }}
          >
            Loyalty Card
          </MenuItem>
          {!userInfo.socialFlag &&
            <MenuItem
              onClick={() => {
                handleProfileMenuItemClik("/account/changepassword")
              }}
            >
              Change Password
            </MenuItem>
          }
          <MenuItem
            onClick={() => {
              handleProfileMenuItemClik("/account/orderhistory")
            }}
          >
            Order History
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleProfileMenuItemClik("/account/wishlist")
            }}
          >
            Wishlist
          </MenuItem>
          <MenuItemDivider />
          <MenuItem
            onClick={() => {
              hideProfileMenu()
              onLogout()
            }}
          >
            Log out
          </MenuItem>
        </AccountMenuBox>
      )} */}
    </>
  )
}

export default withApolloClient(UserInfo, {
  client: "b2bClient",
})
